// src/components/private/Accordion.jsx

import React, { useState, useRef, useEffect } from 'react';

function Accordion({ title, children, isOpen, toggle, icon  }) {
    const accordionRef = useRef(null);
    
    return (
        <div className="mobile-accordion">
            <div className="mobile-header" onClick={toggle}>
                <div className="header-content">
                    {title}
                    {icon && <span className="accordion-icon">{icon}</span>}
                </div>
                <span className="accordion-triangle">{isOpen ? "▼" : "▲"}</span>
            </div>
            {isOpen && <div className="mobile-content">{children}</div>}
        </div>
    );
}

export default Accordion;
